
import angular from 'angular';

angular.module('folkeuni').factory('LectureFilesApi', function($http) {
  var self = this;
  var apiBase = '/api/lecturefiles/';

  self.getSasUrl = function() {
    return $http({
      method: 'get',
      url: apiBase + 'sas'
    });
  };

  self.sendMaterial = function(sendMaterialObj){
    return $http({
      method: 'post',
      data: sendMaterialObj,
      url: apiBase + 'send-material'
    });
  };

  self.uploadFileToBlob = function(url, file) {
    
    return $http({
      method: 'put',
      data: file,
      url: url,
      transformRequest: angular.identity,
      headers: {
          'Content-Type': file.type,
          'x-ms-blob-type': 'BlockBlob'
      }
    })
  };

  return self;
});
